import {TagDefinitionEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {TagDefinitionAction} from "./TagDefinitionActionMenu";
import {useTagDefinitionMutation} from "../../../hooks/useTagDefinitionMutation";

export type UseTagDefinitionActionProps = {}

export type UseTagDefinitionActionResult = {
  onTagDefinitionActionClick: (tagDefinition: TagDefinitionEntity, action: TagDefinitionAction) => void;
}

export const useTagDefinitionAction = (props: UseTagDefinitionActionProps = {}): UseTagDefinitionActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteTagDefinition,
  } = useTagDefinitionMutation()

  const _onTagDefinitionActionClick = useCallback((tagDefinition: TagDefinitionEntity, action: TagDefinitionAction) => {
    if (action === "EDIT") {
      navigate(`/tags/definitions/form`, {state: {id: tagDefinition.id}})
    } else if (action === "DELETE") {
      deleteTagDefinition(tagDefinition.id, undefined)
    }
  }, [navigate, deleteTagDefinition])

  return {
    onTagDefinitionActionClick: _onTagDefinitionActionClick
  }
}
